export default [
  {
    path: '',
    name: 'account-view',
    component: () => import('@/views/account/Account.vue'),
    meta: {
      renderNav: true,
      requireAuth: true,
      title: 'Account',
    },
  },
];